/**
* Třída sloužící k porovnání datových interfaců
*/
export class DataInterfaceComparer {
    /**
     * Vrací, zda se dva datové interfacy rovnají
     */
    public static equals<T>(itemA: T, itemB: T): boolean {
        if (itemA instanceof Object && itemB instanceof Object) {
            const entriesA = Object.entries(itemA).sort();
            const entriesB = Object.entries(itemB).sort();

            // Porovnáme, že se shodují názvy atributů i jejich hodnoty (i názvy, abychom se vyhnuli porovnání hodnot u špatných atributů - např. nepovinné atributy typu boolean)
            return (this.arraysEquals(entriesA.map(([key, _value]) => key), entriesB.map(([key, _value]) => key)) && this.arraysEquals(entriesA.map(([_key, value]) => value), entriesB.map(([_key, value]) => value)));
        }

        if (typeof itemA === "string" && typeof itemB === "string") {
            return (itemA.toLowerCase() === itemB.toLowerCase());
        }

        return (itemA === itemB);
    }

    /**
     * Vrací, zda se pole datových interfaců rovnají
     * @param arrayA - první pole k porovnání
     * @param arrayB - druhé pole k porovnání
     */
    public static arraysEquals<T>(arrayA: T[], arrayB: T[]): boolean {
        if (arrayA == null && arrayB == null) // Pokud jsou pole null nebo undefined, tak se rovnají
            return true;

        if (arrayA == null || arrayB == null) // Pokud je jen jedno (prošla předchozí kontrola) pole null nebo undefined, tak se nerovnají
            return false;

        if (arrayA.length === 0 && arrayB.length === 0) // Pokud jsou obě prázdná, rovnají se
            return true;

        if (arrayA.length !== arrayB.length) // Pokud mají různou délku, nerovnají se
            return false;

        return arrayA.every((itemA, i) => { // Pole obsahují shodný počet prvků, nyní je porovnáme
            return DataInterfaceComparer.equals(itemA, arrayB[i]);
        });
    }
}
